import React from "react";
import { Dropdown } from "react-bootstrap";
import cx from "classnames";

import { FormFieldType } from "src/types/settings/customFormFields";

import styles from "./styles.module.scss";

interface FieldTypeOption {
  type: FormFieldType;
  label: string;
  iconText?: string;
  iconClass?: string;
}

const FIELD_TYPES: FieldTypeOption[] = [
  { type: "string_field",   label: "Text field",     iconText: "Tx" },
  { type: "number_field",   label: "Number field",   iconText: "#"  },
  { type: "boolean_field", label: "Decision field", iconClass: "fa-regular fa-circle-check" },
  { type: "list_field",     label: "List field",     iconClass: "paperflite-list" },
];

interface NewFieldDropdownProps {
  onSelect: (type: FormFieldType) => void;
  disabled?: boolean;
}

const NewFieldDropdown: React.FC<NewFieldDropdownProps> = ({ onSelect, disabled }) => {
  return (
    <div className={styles.selector}>
      <Dropdown>
        <Dropdown.Toggle className={styles.toggle} as="div" disabled={disabled}>
          <i className={cx("paperflite-add", styles.addIcon)} />
          <span className={styles.label}>New form field</span>
        </Dropdown.Toggle>

        <Dropdown.Menu
          className={styles.menu}
          popperConfig={{ strategy: "fixed" }}
          renderOnMount
        >
          {FIELD_TYPES.map(({ type, label, iconText, iconClass }) => (
            <Dropdown.Item
              key={type}
              className={styles.menuItem}
              onClick={() => onSelect(type)}
            >
              <span className={styles.itemLabel}>{label}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default NewFieldDropdown;
